import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, KeyValueId, KeyValueSet, LocalService, Status, SupplierInitialization } from 'src/service/local.service';
import { SupplierService } from 'src/service/supplier.service';

@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrl: './supplier.component.scss'
})
export class SupplierComponent {
  @ViewChild('content_supplier')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() businessId: string = '';
  @Input() id: string = '';

  tabs: KeyValueSet[]; selectedTabKey = '1';
  message: string = ''; isRedAlert: boolean = true;

  supplierInitialization: SupplierInitialization; mandatoryLanguages = [];

  elementIds: any = {
    supplier_name: 'txt_supplier_name',
    supplier_code: 'txt_supplier_code',
    supplier_upi: 'txt_supplier_upi',
    supplier_address: 'txt_supplier_address',
    supplier_notes: 'txt_supplier_notes',
    supplier_bar_code: 'txt_supplier_bar_code',
    first_name: 'txt_supplier_name_m',
    supplier_save: 'btn_supplier_save'
  };

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, private supplierService: SupplierService) {
  }

  ngOnInit(): void {
    this.onInitiate();
  }

  onInitiate() {
    this.mandatoryLanguages.push(this.localService.getSelectedLanguageId());
    this.mandatoryLanguages.push(this.languageManagementService.getEnglishLanguageId());
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.selectedTabKey = '1';
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    if (this.localService.languageContent && this.localService.languageContent.supplier) {
      this.tabs = [
        { key: "1", value: this.localService.languageContent.common.all } as KeyValueSet,
        { key: "2", value: this.localService.languageContent.common.basics } as KeyValueSet,
        { key: "3", value: this.localService.languageContent.supplier.contacts } as KeyValueSet,
        { key: "4", value: this.localService.languageContent.supplier.others } as KeyValueSet
      ];
    }

    this.supplierService.getSupplierInitialization(this.id).subscribe(result => {
      this.supplierInitialization = result;
      this.supplierInitialization.supplier.businessId = this.businessId;
      setTimeout(() => {
        this.localService.onFocusNextInput(this.elementIds.first_name, FocusInputType.TextBox);
      }, 100);
    });
  }


  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.selectedTabKey = key;
      } break;
      case 2: {
        //Save product
        this.onSave();
      } break;
    }
  }

  onSave() {
    this.supplierInitialization.supplier.supportings = [];
    this.supplierInitialization.supporting.forEach(x => {
      this.supplierInitialization.supplier.supportings.push({ key: x.key, value: x.v3 });
    });
    if (this.doCheck()) {
      this.supplierService.saveSupplier(this.supplierInitialization.supplier).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        switch (result.status) {
          case Status.Success: {
            this.onCloseTrigger();
          } break;
        }
      });
    }
  }

  doCheck() {
    let message = '';
    this.isRedAlert = true;
    let wrapper = this.supplierInitialization.supplier;

    if (!wrapper.languageContentsName || wrapper.languageContentsName.filter(x => x.v3.trim() != '').length == 0) {
      message = this.localService.languageContent.supplier.need_name;
      this.localService.onFocusNextInput(this.elementIds.first_name, FocusInputType.TextBox);
    }

    this.message = message;
    if (this.message != '') {
      //this.localService.showInformation(this.message, this.isRedAlert);
    }
    return message == '';
  }


  onEmptyLanguageContainerAdded(languageContents: any, index) {
    switch (index) {
      case 1: {
        this.supplierInitialization.supplier.languageContentsName = languageContents;
      } break;
      case 2: {
        this.supplierInitialization.supplier.languageContentsAddress = languageContents;
      } break;
      case 3: {
        this.supplierInitialization.supplier.languageContentsDescription = languageContents;
      } break;
    }
  }

  onValuesUpdated(values: any, index) {
    switch (index) {
      case 1: {
        this.supplierInitialization.supplier.contactNumbers = values;
      } break;
      case 2: {
        this.supplierInitialization.supplier.emails = values;
      } break;
    }
  }

  onQrScanned(value) {
    this.supplierInitialization.supplier.content.v3 = value;
  }
}
